import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { City } from "../City";
/**
 * Country class
 */

export class Country extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => {
      return this.model.id;
    };

    this.getCode = () => {
      return this.model.code;
    };

    this.getTitle = () => {
      return this.model.title;
    };

    this.getCurrency = () => {
      return this.model.currency;
    };

    this.getLangCode = () => {
      return this.model.langCode;
    };

    this.isEnable = () => {
      return this.model.isEnable;
    };

    this.getHoliday = () => {
      return this.model.holidays || [];
    };

    this.getLatitude = () => {
      return Number(this.model.latitude);
    };

    this.getLongitude = () => {
      return Number(this.model.latitude);
    };

    this.getCities = cities => {
      return this.getRelation('cities', City, cities, true);
    };

    this.getCapital = capital => {
      return this.getRelation('capital', City, capital);
    };

    this.getRegionalCities = regionalCities => {
      return this.getRelation('regionalCities', City, regionalCities, true);
    };

    this.getDefaultCity = defaultCity => {
      return this.getRelation('defaultCity', City, defaultCity);
    };
  }

  /**
   * Create country
   *
   * @param {object} object
   *
   * @return {Country}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list country
   *
   * @param {object} objects
   *
   * @return {Array.<Country>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map countries
   *
   * @param {Array.<object>} objects
   * @param {function(Country): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get country id
   *
   * @return {number}
   */


}